import { Fragment } from "react";
import Stack from "@vapor/react-material/Stack";
import Button from "@vapor/react-material/Button";
import FormGroup from "@vapor/react-material/FormGroup";
import FormControlLabel from "@vapor/react-material/FormControlLabel";
import Radio from "@vapor/react-material/Radio";
import Box from "@vapor/react-material/Box";
import Menu from "@vapor/react-material/Menu";
import MenuItem from "@vapor/react-material/MenuItem";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

export const AnagraficaVersionBar = ({
  clienteAnagType,
  currentAnagrafica,
  currentAnagraficaFascicolo,
  versioni,
  anchorEl,
  isCessato,
  isNotLastVersion,
  userPermissions,
  loggedUserId,
  onMenuOpen,
  onMenuClose,
  onSelectVersion,
  onDeleteVersion,
}) => {
  const open = Boolean(anchorEl);

  return (
    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
      <FormGroup>
        <div>
          <FormControlLabel
            control={
              <Radio
                checked={clienteAnagType === "PG"}
                value="Persona Giuridica"
                name="radio-buttons"
                id="checkPg"
                disabled={true}
                inputProps={{ "aria-label": "Persona giuridica" }}
              />
            }
            label="Persona giuridica"
          />
          <FormControlLabel
            control={
              <Radio
                checked={clienteAnagType === "DI"}
                value="Ditta individuale"
                name="radio-buttons"
                id="checkDi"
                disabled={true}
                inputProps={{ "aria-label": "Ditta individuale" }}
              />
            }
            label="Ditta individuale"
          />
          <FormControlLabel
            control={
              <Radio
                checked={clienteAnagType === "PF"}
                value="Persona Fisica"
                name="radio-buttons"
                id="checkPf"
                disabled={true}
                inputProps={{ "aria-label": "Persona fisica" }}
              />
            }
            label="Persona fisica"
          />
        </div>
      </FormGroup>

      <Box flexGrow={1} />

      {currentAnagrafica.id > 0 ? (
        <Fragment>
          <Stack direction="row" spacing={1}>
            <Button
              id="versioniMenuButton"
              aria-controls={open ? "aziendeMenu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableelevation="true"
              onClick={onMenuOpen}
              endIcon={<KeyboardArrowDownIcon />}
              size="small"
              disabled={
                currentAnagraficaFascicolo.id === 0 ||
                currentAnagrafica.id === 0 ||
                isCessato ||
                (isNotLastVersion && versioni.length <= 1)
              }
            >
              Versione n. {currentAnagrafica.versionN} 
              {currentAnagrafica.versionDate
                ? <> dal {new Date(currentAnagrafica.versionDate).toLocaleDateString()}</>
                : ""}
            </Button>

            {versioni.length > 0 ? (
              <Menu
                id="versioniMenu"
                aria-labelledby="versioniMenuButton"
                anchorEl={anchorEl}
                open={open}
                onClose={onMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                {versioni.map((item, index) => (
                  <MenuItem
                    key={item.id}
                    dense
                    onClick={() => onSelectVersion(item)}
                    selected={(item.id === currentAnagrafica.id) === item.id}
                  >
                    <ExtendedTypography variant="body2">
                      Versione n. {item.versionN} dal{" "}
                      {new Date(item.versionDate).toLocaleDateString()}
                      {index > 0
                        ? " al " +
                          new Date(versioni[index - 1].versionDate).toLocaleDateString()
                        : null}
                    </ExtendedTypography>
                  </MenuItem>
                ))}
              </Menu>
            ) : null}

            {versioni.length > 1 &&
              currentAnagrafica.versionN === versioni[0].versionN &&
              (currentAnagrafica.identifiedByUser === loggedUserId ||
                currentAnagrafica.createdBy === loggedUserId) &&
              userPermissions.canDelete ? (
              <Button
                variant="contained"
                color="error"
                onClick={() => onDeleteVersion(currentAnagrafica)}
                disabled={isCessato || isNotLastVersion}
                endIcon={<DeleteIcon />}
                size="small"
              >
                Elimina
              </Button>
            ) : null}
          </Stack>
        </Fragment>
      ) : null}
    </Stack>
  );
};
